import {
    FETCH_LOANDETAIL_BEGIN,
    FETCH_LOANDETAIL_SUCCESS,
    FETCH_LOANDETAIL_FALIURE,
} from "../actions/loanDetailAction";

const initialState = {
    loanDetailData: '',
    loading: false,
    error: null,

}

export default function loanDetailReducer(
    state = initialState,
    action
) {
    switch (action.type) {
        case FETCH_LOANDETAIL_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            }

        case FETCH_LOANDETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                loanDetailData: action.payload.loanDetail
            }

        case FETCH_LOANDETAIL_FALIURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                loanDetailData: ''
            }
        default:
            return state;
    }
}